/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export { ApiError } from './core/ApiError';
export { OpenAPI } from './core/OpenAPI';

export type { Antwort } from './models/Antwort';
export type { antwortenDto } from './models/antwortenDto';
export type { AntwortenFromAufgabe } from './models/AntwortenFromAufgabe';
export type { AntwortKontext } from './models/AntwortKontext';
export type { AntwortTimestamp } from './models/AntwortTimestamp';
export type { AntwortToken } from './models/AntwortToken';
export type { AntwortTokenStamp } from './models/AntwortTokenStamp';
export type { Aset } from './models/Aset';
export type { Aufgabe } from './models/Aufgabe';
export type { aufgabenDto } from './models/aufgabenDto';
export type { AufgabeStamp } from './models/AufgabeStamp';
export type { IGetAllSpposResult } from './models/IGetAllSpposResult';
export type { IGetPresetOrtTagResult } from './models/IGetPresetOrtTagResult';
export type { IGetPresetTagsResult } from './models/IGetPresetTagsResult';
export type { ISelectAllAufgabenResult } from './models/ISelectAllAufgabenResult';
export type { ISelectAllTeamsResult } from './models/ISelectAllTeamsResult';
export type { ISelectAufgabenFromSetResult } from './models/ISelectAufgabenFromSetResult';
export type { ISelectAufgabenResult } from './models/ISelectAufgabenResult';
export type { ISelectAufgabenSetResult } from './models/ISelectAufgabenSetResult';
export type { ISelectAusbildungResult } from './models/ISelectAusbildungResult';
export type { ISelectErhebungsartenResult } from './models/ISelectErhebungsartenResult';
export type { ISelectInfErhebungenResult } from './models/ISelectInfErhebungenResult';
export type { ISelectMatchingTokensResult } from './models/ISelectMatchingTokensResult';
export type { ISelectOrtAufgabeResult } from './models/ISelectOrtAufgabeResult';
export type { ISelectOrtTagsResult } from './models/ISelectOrtTagsResult';
export type { ISelectPhaenBerResult } from './models/ISelectPhaenBerResult';
export type { ISelectPhaenResult } from './models/ISelectPhaenResult';
export type { ISelectSatzResult } from './models/ISelectSatzResult';
export type { ISelectSingleGenResult } from './models/ISelectSingleGenResult';
export type { ISelectSinglePhaenResult } from './models/ISelectSinglePhaenResult';
export type { ISelectTagByIdResult } from './models/ISelectTagByIdResult';
export type { ISelectTagByPhaenResult } from './models/ISelectTagByPhaenResult';
export type { ISelectTagsLayersResult } from './models/ISelectTagsLayersResult';
export type { numberArray } from './models/numberArray';
export type { phaenDto } from './models/phaenDto';
export type { selectionObject } from './models/selectionObject';
export type { tagDto } from './models/tagDto';
export type { TagTree } from './models/TagTree';

export { Service } from './services/Service';
